import React from 'react'
import { useMutation } from 'react-query'
import { API_METHODS } from 'constants/api-methods'
import { BASE_API_URL } from 'constants/env'
import { useApiRequest } from 'hooks/use-api-request'
import toast from 'react-hot-toast'

interface CreateCancelTicketParams {
  user_id: string
}

interface CreateCancelTicketResponse {
  success: boolean
  data: {
    ticket_id: string
    user: {
      id: string
      name: string
      email: string
    }
    apple_id: {
      id: string
      phone_number: string
      email: string
    }
    organization: {
      id: string
      name: string
    }
  }
}

const useCreateCancelTicket = () => {
  const api = useApiRequest()

  const mutation = useMutation(
    async ({ user_id }: CreateCancelTicketParams) => {
      return api<CreateCancelTicketResponse>({
        url: `${BASE_API_URL}/admin/api/v2/canceled_numbers`,
        apiMethod: API_METHODS.POST,
        data: { user_id },
      })
    },
    {
      onSuccess: (data, variables) => {
        toast.success(
          'Cancel ticket is being created in the background. Once the HubSpot ticket is created, the user will be automatically detached from this blue number.',
          {
            duration: 5000,
            style: {
              background: '#343a40',
              color: '#fff',
              border: '1px solid #495057',
            },
          }
        )
      },
      onError: (error: Error) => {
        toast.error(`Failed to create cancel ticket: ${error.message}`, {
          style: {
            background: '#343a40',
            color: '#fff',
            border: '1px solid #495057',
          },
        })
      },
    }
  )

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  }
}

export default useCreateCancelTicket
